import { ToolbarText } from '@kerfjs/ui/toolbar-text';
import type { SafeHtml } from 'kerfjs';

import { EditableToolbarTitle } from '../../../components/editable-toolbar-title.js';
import { chatActiveId, chatConversations, chatTitleEditing } from '../../../data/state.js';

/** Read/edit title control for the active project chat. */
export function ProjectChatTitleControl(): SafeHtml {
  const conversation = chatConversations.value.find((item) => item.id === chatActiveId.value);
  if (conversation === undefined) return <ToolbarText text="Chat" />;
  const rawTitle = conversation.title?.trim();
  const title = rawTitle === undefined || rawTitle === '' ? 'Untitled chat' : rawTitle;
  return (
    <EditableToolbarTitle
      label="Chat Title"
      hook="project-chat-title"
      editing={chatTitleEditing.value}
      value={title}
      inputAction="project-chat-title-input"
      editAction="edit-project-chat-title"
      display={title}
    />
  );
}
